<template>
  <div class="row">
    <div class="col-sm-6 col-lg-2">
      <div class="form-group">
        <label class="label" for="salutation">{{ $t("salutation") }}</label>
        <select name="salutation" id="tisalutationle" class="form-select" v-model="theModel.salutation">
          <option disabled value="">{{ $t("pls-select") }}</option>
          <option>{{ $t("male") }}</option>
          <option>{{ $t("female") }}</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 col-lg-2" v-if="templateversion == 'adult'">
      <div class="form-group">
        <label class="label" for="title">{{ $t("title") }}</label>
        <input class="form-control" type="text" name="title" required="" v-model="theModel.title"/>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="form-group">
        <label class="label" for="firstname">{{ $t("firstname") }}</label>
        <input class="form-control" type="text" name="firstname" required="" v-model="theModel.firstname" />
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="form-group">
        <label class="label" for="lastname">{{ $t("lastname") }}</label>
        <input class="form-control" type="text" name="lastname" required="" v-model="theModel.lastname"/>
      </div>
    </div>
  </div>
</template>

<script >
import { computed } from "vue";
export default {
  // inject: ["reservation"],
  name: "OrderFormGuest",
  props: {
    modelValue: {
      // Declare the property
      type: Object,
      default: () => ({}), // default value
    },
    templateversion: {
      // Declare the property
      type: Text,
      default: () => "", // efault value
    },
  },
  setup(props, { emit }) {
    const theModel = computed({
      // Use computed to wrap the object
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    return { theModel };
  },
};
</script>